import React, { Component } from 'react';
import * as StockIssueAction from '../actions/StockIssueAction';
import StockIssueStore from '../stores/StockIssueStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next';
import { display } from '@material-ui/system';
import DatePicker from "react-datepicker";
import * as MenuAction from '../actions/MenuAction';
import swal from 'sweetalert';
let currentPagePath;
const Options = [
    { label: "Last 7 Days", value: "1" },
    { label: "Last 15 Days", value: "2" },
    { label: "Last 30 Days", value: "3" },
    { label: "This Month", value: "4" },
    { label: "Last Month", value: "5" },
    { label: "Select By Date", value: "6" }
];
class StockIssueComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            GridArray: [],
            BUArray: [],
            DropDownVal: "0",
            DropDownText: "Select",
            BUTextBoxval: "",
            IsBinLocChecked: false,
            IsQtyOnHandChecked: false,
            ColumnName: "",
            anchorEl: null,
            open: false,
            SortBy: "",
            total: "0",
            IsPageLoad: false,
            totalCount: 0,
            itemCount: 10,
            pageCount: 0,
            pageNo: 1,
            FromDate: "",
            IsPageLoad: false,
            OFromDate: null,
            OToDate: null,
            isSearchByDate: false,
            BUOptions: [],
            BUDropDownText: "Select",
            BUDropDownVal: "0",
            BUDDDisplayName: "Select",
            total: "0",
            isFavorited: false,
            /*[06/16/22,WW-431,PC_01], Priyanka D */
            Pickup: "",
            EmpName: "Select"
        }
    }
    componentDidMount() {
        
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        StockIssueAction.getCurrentFavPage(getFavPageBO);
        this.PageLoad();
        StockIssueStore.on('BuData', this.PageLoadResponse);
        StockIssueStore.on('GridData', this.GoClickResponse);
        StockIssueStore.on('Export', this.FileExport);
        StockIssueStore.on('Total', this.TotalCalculate);
        StockIssueStore.on('favpage', this.loadFavPageResponse.bind(this));
        StockIssueStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
    }
    componentWillUnmount() {
        StockIssueStore.removeListener('BuData', this.PageLoadResponse);
        StockIssueStore.removeListener('GridData', this.GoClickResponse);
        StockIssueStore.removeListener('Export', this.FileExport);
        StockIssueStore.removeListener('Total', this.TotalCalculate);
        StockIssueStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        StockIssueStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
    }
    //This Method is used to invoke the pageload method in API to get BU list
    PageLoad = () => {
        
        let PageLoadBO = {
            /*[06/16/22,WW-431,PC_02], Priyanka D */
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
            Session_THIRDPARTY_COMP_ID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        StockIssueAction.PageLoad(PageLoadBO);
    }
    //This Method is used to setstate BU list data to an array
    PageLoadResponse = () => {
        
        /*[06/16/22,WW-431,PC_04], Priyanka D */
        let EmployeeName = [];
        let PageLoadBU = JSON.parse(StockIssueStore.PageLoadData);
        let BuArraydata = PageLoadBU.PageLoadResponse;
        let EmpName = PageLoadBU.EmployeeName
        if (EmpName.length > 0) {
            EmpName.map((val, index) => {
                let localArray = {
                    value: val.EMP_ID,
                    label: val.ISA_EMPLOYEE_NAME,//WBW-15_PC_03 to display the crib name (2/18/2022) -Aparna
                }
                EmployeeName.push(localArray)
            });
            this.setState({ EmpOptions: EmployeeName });
        }
        if (BuArraydata.length > 0) {
            this.setState({
                BUArray: BuArraydata, IsPageLoad: true
            });
        }
        this.BuDD();
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //This Method is used to dynamically bind the label and vaue for BU DropDown
    BuDD = () => {
        
        let BUValue = []
        if (this.state.BUArray.length > 0) {
            this.state.BUArray.map((val, index) => {
                //if (index == 0) {
                //    let defaultvalue = {
                //        value: index,
                //        label: "Select",
                //    }
                //    BUValue.push(defaultvalue)
                //}
                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCR,
                }
                BUValue.push(localArray)

            });
        }
        this.setState({ BUOptions: BUValue });

    };
    //This Method is used to setstate the selected value from the BU Dropdown
    handleBUDDChange = (values) => {
        
        this.setState(
            { BUDropDownVal: values.value, BUDropDownText: values.value, BUDDDisplayName: values.label });
    }
    handleWOInput = (e) => {
        
        let WOrkorder = this.state.WOrkorder
        const re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value != "0") {
                this.setState({ WOrkorder: e.target.value });
                WOrkorder = e.target.value
            }

        }
        //Had issue when we type special characters. It is accepting special character though we use regex. So used Javascript fuc too-Priyanka D
        if (WOrkorder != undefined && WOrkorder != " " && WOrkorder != null) {
            document.getElementById("OLWorkOrderTB").value = WOrkorder
        } else {
            document.getElementById("OLWorkOrderTB").value = ""
        }

        console.log("WOrkorder", this.state.WOrkorder);
        console.log("WOrkorder1", document.getElementById("OLWorkOrderTB").value);
    }
    //This Method is used to setstate the selected value from the Select Report Dropdown
    handleDDChange = (values) => {
        
        let IsOpen = false
        if (values.value == "6") {
            IsOpen = true;
        }
        this.setState(
            { DropDownVal: values.value, DropDownText: values.label, isSearchByDate: IsOpen });
    }
    /*[06/16/22,WW-431,PC_05], Priyanka D */
    handleEmpChange = (values) => {
        
        this.setState(
            { EmpName: values.label, EmpValue: values.value });
    }
    /*[06/16/22,WW-431,PC_06], Priyanka D */
    OnchangePick = (PickType) => {
        let Pickup = ""
        if (PickType == "0") {
            Pickup = "Y"
            document.getElementById("Pickup").checked = true;
            document.getElementById("NotPickup").checked = false;
        } else {
            Pickup = "N"
            document.getElementById("Pickup").checked = false;
            document.getElementById("NotPickup").checked = true;
        }
        this.setState({ Pickup: Pickup })
    }
    //This Method is used to store the export to excel success message and its response
    FileExport = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let expfile = JSON.parse(StockIssueStore.Excel);

    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(StockIssueStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    updateFavPageResponse = () => {
        if (StockIssueStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(StockIssueStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(StockIssueStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        this.refreshMenu();
    };
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true//isFirstTimeLoaded
        };
        console.log("masterBO", masterBO);
        MenuAction.getMasterData(masterBO);
    };
    //This Method is invoked when the User clicks on the GO Button
    GoClick = () => {
        
        //let BUTextBoxval = $('#buddid').text();
        if (this.state.DropDownVal == "0") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select Any Report"
            });
            //  alert("Please select Any Report");
        }
        //[10/17/22, Bug - 2732 - From date validation, Dhevanesam R]
        else if (this.state.DropDownVal == "6" && (this.state.OFromDate == "" || this.state.OFromDate == null || this.state.OFromDate == undefined)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Select From Date"
            });
            //alert("Please Select From Date");
        }
        //[10/17/22, Bug - 2732 - To date validation, Dhevanesam R]
        else if (this.state.DropDownVal == "6" && (this.state.OToDate == "" || this.state.OToDate == null || this.state.OToDate == undefined)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Select To Date"
            });
            //  alert("Please Select To Date");
        }
        else {
            this.SetDates();
        }

    }
    /*[06/16/22,WW-431,PC_06], Priyanka D */
    ClearClick = () => {
        document.getElementById("OLWorkOrderTB").value = "";
        document.getElementById("Pickup").checked = false;
        document.getElementById("NotPickup").checked = false;
        this.setState({ Pickup: "", DropDownVal: "0", EmpName: "Select", OFromDate: "", OToDate: "", BUDDDisplayName: "Select", DropDownText: "Select", isSearchByDate: false, BUDropDownVal: "0", BUDropDownText: "", WOrkorder: "" })
    }
    //This Method is invoked when the User clicks on the Submit Button which is inside the Search By Date PopUp
    SubmitClick = () => {
        
        let tdat = this.state.OToDate;
        let today = (tdat.getMonth() + 1) + '/' + (tdat.getDate()) + '/' + tdat.getFullYear();
        let tmonth = tdat.getMonth() + 1;
        let fdat = this.state.OFromDate;
        let prevday = (fdat.getMonth() + 1) + '/' + (fdat.getDate()) + '/' + fdat.getFullYear();
        let fmonth = fdat.getMonth() + 1;
        let diff = tmonth - fmonth;
        let difday = Date(prevday) - Date(today);
        //WBW - 6(The C0W10 label in the dropdown is showing the description for I0W01 instead of C0W10)-Deepthi
        let date1 = new Date(prevday);
        let date2 = new Date(today);
        let oneDay = 1000 * 60 * 60 * 24;
        let diffInTime = date2.getTime() - date1.getTime();
        let diffInDays = Math.round(diffInTime / oneDay);
        //let diffInMs = Math.floor((Math.abs(Date(prevday) - Date(today))) / (1000 * 60 * 60 * 24))

        if (diffInDays > 90) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Date range exceeds 3 months"
            });
            //  alert("Date range exceeds 3 months");
        }
        else {
            let GridDataBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                DropDownVal: this.state.DropDownVal,
                DropDownText: this.state.DropDownText,
                ColumnName: this.state.ColumnName,
                SortBy: this.state.SortBy,
                FromDate: prevday.toString(),
                ToDate: today.toString(),
                PageNo: this.state.pageNo,
                ItemCount: this.state.itemCount,
                BUDropDownVal: this.state.BUDropDownVal,
                BUDropDownText: this.state.BUDropDownText,
                Pickup: this.state.Pickup,
                EmpName: (this.state.EmpName != null && this.state.EmpName != undefined && this.state.EmpName != "" && this.state.EmpName.toLowerCase() != 'select' ? this.state.EmpName : ""),
                WO: (document.getElementById("OLWorkOrderTB").value != null && document.getElementById("OLWorkOrderTB").value != undefined && document.getElementById("OLWorkOrderTB").value != "" ? document.getElementById("OLWorkOrderTB").value : "")

            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            StockIssueAction.GridDataLoad(GridDataBO);
            StockIssueAction.GetTotal(GridDataBO);
            this.setState({
                FromDate: prevday.toString(),
                IsPageLoad: false,
                ToDate: today.toString(),

            });
        }


    }
    //This Method is Used to set From and To Dates based on the selected report value from the dropdown and also
    //invokes the GridLoad method 
    SetDates = () => {
        ;
        /*[06/16/22,WW-431,PC_07], Priyanka D */
        let today = new Date();
        today = (today.getMonth() + 1) + '/' + (today.getDate()) + '/' + today.getFullYear();
        let myCurrentDate = Date.now();
        let myPastDate = new Date(myCurrentDate);
        if (this.state.DropDownVal == "1") {
            myPastDate.setDate(myPastDate.getDate() - 7);
            myPastDate = (myPastDate.getMonth() + 1) + '/' + (myPastDate.getDate()) + '/' + myPastDate.getFullYear();
        }
        else if (this.state.DropDownVal == "2") {
            myPastDate.setDate(myPastDate.getDate() - 15);
            myPastDate = (myPastDate.getMonth() + 1) + '/' + (myPastDate.getDate()) + '/' + myPastDate.getFullYear();
        }
        else if (this.state.DropDownVal == "3") {
            myPastDate.setDate(myPastDate.getDate() - 30);
            myPastDate = (myPastDate.getMonth() + 1) + '/' + (myPastDate.getDate()) + '/' + myPastDate.getFullYear();
        }
        else if (this.state.DropDownVal == "4") {
            myPastDate.setDate(myPastDate.getDate());
            myPastDate = (myPastDate.getMonth() + 1) + '/' + '1' + '/' + myPastDate.getFullYear();
        }
        else if (this.state.DropDownVal == "5") {
            let thisday = new Date();
            let firstDay = new Date(thisday.getFullYear(), thisday.getMonth() - 1, 1);
            let lastDay = new Date(thisday.getFullYear(), thisday.getMonth(), 0);
            today = (lastDay.getMonth() + 1) + '/' + (lastDay.getDate()) + '/' + lastDay.getFullYear();
            myPastDate = (firstDay.getMonth() + 1) + '/' + (firstDay.getDate()) + '/' + firstDay.getFullYear();
        }
        /*Business Unit condition change - PROD issues - Priyanka D*/
        else if (this.state.DropDownVal == "6") {
            let tdat = this.state.OToDate;
            today = (tdat.getMonth() + 1) + '/' + (tdat.getDate()) + '/' + tdat.getFullYear();
            let tmonth = tdat.getMonth() + 1;
            let fdat = this.state.OFromDate;
            let prevday = (fdat.getMonth() + 1) + '/' + (fdat.getDate()) + '/' + fdat.getFullYear();
            let fmonth = fdat.getMonth() + 1;
            myPastDate = prevday.toString();
            today = today.toString();
        }
        let months;
        months = (new Date(this.state.OToDate).getDate() - new Date(this.state.OFromDate).getDate()) / 30 +
            new Date(this.state.OToDate).getMonth() - new Date(this.state.OFromDate).getMonth() +
            (12 * (new Date(this.state.OToDate).getFullYear() - new Date(this.state.OFromDate).getFullYear()));

        //let diff = (TrT.getTime() - TrF.getTime()) / 1000;
        //    diff /= (60 * 60 * 24 * 7 * 4);
        //    //return Math.abs(Math.round(diff));
        //console.log("diff", Math.round(diff));
        if (months > 3) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Date range should be within 3 months"
            });
            //  alert("Date range should be within 3 months");
        } else {
            let GridDataBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                DropDownVal: this.state.DropDownVal,
                DropDownText: this.state.DropDownText,
                ColumnName: this.state.ColumnName,
                SortBy: this.state.SortBy,
                FromDate: myPastDate.toString(),
                ToDate: today.toString(),
                PageNo: 1,
                ItemCount: this.state.itemCount,
                BUDropDownVal: this.state.BUDropDownVal,
                BUDropDownText: this.state.BUDropDownText,
                Pickup: this.state.Pickup,
                EmpName: (this.state.EmpName != null && this.state.EmpName != undefined && this.state.EmpName != "" && this.state.EmpName != "Select" ? this.state.EmpName : ""),
                WO: (document.getElementById("OLWorkOrderTB").value != null && document.getElementById("OLWorkOrderTB").value != undefined && document.getElementById("OLWorkOrderTB").value != "" ? document.getElementById("OLWorkOrderTB").value : "")

            }
            this.setState({
                FromDate: myPastDate.toString(),
                IsPageLoad: false,
                ToDate: today.toString()
            });
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            StockIssueAction.GridDataLoad(GridDataBO);
            StockIssueAction.GetTotal(GridDataBO);

        }
    }

    //This Method is Used to store the GridData into an array
    GoClickResponse = () => {
        
        let BindGrid = JSON.parse(StockIssueStore.GridData);
        //Exception handling-Priyanka D
        if (BindGrid == undefined || BindGrid == null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue. Please contact SDI customer care!"
            });
            // alert("Technical Issue. Please contact SDI customer care!");
        }
        else {
            let BindGridData = BindGrid.Table;
            if (BindGridData.length > 0) {
                let tc = BindGrid.Table[0].TOTAL_COUNT;

                //let  pc = Math.ceil((tc > 0 ? tc : 0);
                this.setState({
                    GridArray: BindGridData,
                    IsPageLoad: false,
                    totalCount: tc,
                    pageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.itemCount)
                });

            }
            else {
                this.setState({
                    GridArray: [], totalCount: 0
                });
            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //This Method is used to calculate the total dollars of all the records
    TotalCalculate = () => {
        
        let total = JSON.parse(StockIssueStore.Total);
        let TotalData = total.Table;
        let loctotal = 0;
        if (TotalData.length > 0) {
            TotalData.map((item, index) => {
                loctotal += parseFloat(item.TOT_COST);
            })
        }
        let formtot = parseFloat(loctotal.toFixed(2));
        loctotal = (formtot).toLocaleString('en');
        //loctotal = parseFloat(loctotal).toFixed(2);
        console.log("totalvalue", loctotal);
        this.setState({ total: loctotal });
    }
    //This Method is used to setstate the changed dates chosen from the datepicker
    handleDatePicker = (date, name) => {
        ;
        let dateOL = this.handledate(date);
        this.setState({
            [name]: date
        });

    };
    //This Method is used to format the dates to a particular format
    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }
    }
    //This Method is used to expand all the accordians
    expandAll = () => {
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('.content-row').addClass('d-none');
        $('.header-arrow').addClass('accordion-arrow-change');
        $('.content-row').removeClass('d-none');
    }
    //This Method is used to close all the accordians
    collapseAll = () => {
        $('.header-arrow').addClass('accordion-arrow-change');
        $('.content-row').removeClass('d-none');
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('.content-row').addClass('d-none');
    }
    //This Method is used to sort the grid date based on the selected column and its type
    SortClick = (event, sortBy, columnName) => {
        let GridDataBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            DropDownVal: this.state.DropDownVal,
            DropDownText: this.state.DropDownText,
            ColumnName: columnName,
            SortBy: sortBy,
            FromDate: this.state.FromDate,
            ToDate: this.state.ToDate,
            PageNo: 1,
            ItemCount: this.state.itemCount,
            BUDropDownVal: this.state.BUDropDownVal,
            BUDropDownText: this.state.BUDropDownText,
            Pickup: this.state.Pickup,
            EmpName: (this.state.EmpName != null && this.state.EmpName != undefined && this.state.EmpName != "" && this.state.EmpName != "Select" ? this.state.EmpName : ""),
            WO: (document.getElementById("OLWorkOrderTB").value != null && document.getElementById("OLWorkOrderTB").value != undefined && document.getElementById("OLWorkOrderTB").value != "" ? document.getElementById("OLWorkOrderTB").value : "")

        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        StockIssueAction.GridDataLoad(GridDataBO);
        this.setState({ ColumnName: columnName, SortBy: sortBy });
    };
    //This Method is invoked when export to excel button is clicked and invokes exportdata action method
    ExportToExcelClick = () => {
        
        let ExcelBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            DropDownVal: this.state.DropDownVal,
            DropDownText: this.state.DropDownText,
            ColumnName: this.state.ColumnName,
            SortBy: this.state.SortBy,
            FromDate: this.state.FromDate,
            ToDate: this.state.ToDate,
            PageNo: "0",
            ItemCount: this.state.itemCount,
            BUDropDownVal: this.state.BUDropDownVal,
            BUDropDownText: this.state.BUDropDownText,
            Pickup: this.state.Pickup,
            EmpName: (this.state.EmpName != null && this.state.EmpName != undefined && this.state.EmpName != "" && this.state.EmpName != "Select" ? this.state.EmpName : ""),
            WO: (document.getElementById("OLWorkOrderTB").value != null && document.getElementById("OLWorkOrderTB").value != undefined && document.getElementById("OLWorkOrderTB").value != "" ? document.getElementById("OLWorkOrderTB").value : "")

        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        StockIssueAction.ExportData(ExcelBO);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //This Method is used to invoke the GridData method on the selection of each page
    handlePageClick = (data) => {
        
        let pageNo = data.selected + 1;
        this.setState({ pageNo: pageNo });
        let GridDataBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            DropDownVal: this.state.DropDownVal,
            DropDownText: this.state.DropDownText,
            ColumnName: this.state.ColumnName,
            SortBy: this.state.SortBy,
            FromDate: this.state.FromDate,
            ToDate: this.state.ToDate,
            PageNo: pageNo,
            ItemCount: this.state.itemCount,
            BUDropDownVal: this.state.BUDropDownVal,
            BUDropDownText: this.state.BUDropDownText,
            Pickup: this.state.Pickup,
            EmpName: (this.state.EmpName != null && this.state.EmpName != undefined && this.state.EmpName != "" && this.state.EmpName != "Select" ? this.state.EmpName : ""),
            WO: (document.getElementById("OLWorkOrderTB").value != null && document.getElementById("OLWorkOrderTB").value != undefined && document.getElementById("OLWorkOrderTB").value != "" ? document.getElementById("OLWorkOrderTB").value : "")

        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        StockIssueAction.GridDataLoad(GridDataBO);

    };
    //This method is used to handle the fav icon
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Stock Issue Report",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            StockIssueAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            StockIssueAction.deleteFavPage(deleteFavPageBO)
        }
    };

    //This Method is used to close and open the accordian
    onAccordianClick = (event, index) => {
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#contentrow-${index}`).toggleClass('d-none');
        $('tr').removeClass('tr-border');
        $(event.currentTarget).parent('tr').addClass('tr-border');

    };
    //This Method is used to clear the data in the SearchByDate Popup
    clearButtonClick = () => {
        this.setState({ OFromDate: "", OToDate: "", PageNo: 1 });
    }
    //This Method is used to close the SearchByDate Popup
    closeButtonClick = () => {
        this.setState({ DropDownVal: "0", DropDownText: "Select" });
    }
    //This Method is used to bind the grid data
    BindGridData = () => {
        
        console.log("GridArray1", this.state.GridArray);
        return this.state.GridArray.map((order, index) => {
            console.log("GridArray2", this.state.GridArray);
            let orderarray = this.state.GridArray;
            let orderLineItemCount = this.state.GridArray.length // this.state.GridArray.filter((value, indexVal) => value.PRODUCT_ID == order.PRODUCT_ID).length;
            //let FilteredArray = this.state.GridArray.filter((value, indexVal) =>  value.PRODUCT_ID == order.PRODUCT_ID);
            //
            //console.log("orderlineitem", FilteredArray);
            //console.log("orderlineitemprod", FilteredArray[0].PRODUCT_ID);
            let qty = parseFloat(order.QTY).toFixed(4);
            let Totalcost = parseFloat(order.TOT_COST).toFixed(2);
            return (<React.Fragment key={`key${index}`}>
                <tr>
                    <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)} >
                        <span className="accordion-arrow header-arrow" id={`arrow-${index}`} />
                    </td>
                    <td className="d-md-table-cell">{order.PRODUCT_ID}</td>
                    <td className="d-md-table-cell">{order.ORDER_NO}</td>
                    <td className="d-md-table-cell">{order.SHORT_DESCR}</td>
                    <td className="d-md-table-cell">{order.SHIP_FROM_BU}</td>
                    <td className="d-md-table-cell">{order.ORDER_INT_LINE_NO}</td>
                    <td className="d-md-table-cell">{qty}</td>
                    <td className="d-md-table-cell">{order.SERIAL_ID}</td>
                    <td className="d-md-table-cell">${Totalcost}</td>
                    <td className="d-md-table-cell">{order.ISA_EMPLOYEE_NAME}</td>
                    {/*<td className="d-sm-none d-md-table-cell">{order.ISA_EMPLOYEE_ID}</td>*/}
                    <td className="d-md-table-cell">{order.ISA_WORK_ORDER_NO}</td>
                </tr>
                <tr className="p d-none content-row" id={`contentrow-${index}`}>
                    <td colSpan="16" className="hiddenRow" id="order-row-1">
                        <div className="py-1" id={`order-row-${index}`}>
                            {orderLineItemCount > 0 ? <React.Fragment>
                                <h4 className="item-details-title float-left">Item Details</h4>
                                {this.bindOrderLineItems(order.PRODUCT_ID, order.ORDER_NO)}
                            </React.Fragment> : `No line items are present in this order`}
                        </div>
                    </td>
                </tr>
            </React.Fragment>);

        })
    };
    //This method gets the Item Id and Order NO as parameters and binds the line items based on the Item Id and Order NO
    bindOrderLineItems = (ProductNo, ORDER_NO) => {
        let childItems = this.state.GridArray.filter((item, index) => item.PRODUCT_ID == ProductNo && item.ORDER_NO == ORDER_NO);
        return childItems.map((childItem, childindex) => {
            return (<div className="col-md-12 float-left mx-0 mb-3 pt-3 pb-2" key={childindex}>
                <div className="accordian-body  py-1 mt-3 ml-4 pl-2" id="order-row-1">
                    <div className="row mx-0 pb-0">
                        <div className="col-md-10 pl-4 mb-1" style={{ "marginTop": "2px", "marginBottom": "2px" }}>
                            <div className="row">
                                <div className="col-md-10 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Description:</label>
                                    <label className="item-details-value my-1">{childItem.DESCR254}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Charge Code:</label>
                                    <label className="item-details-value mb-2">{childItem.ISA_CUST_CHARGE_CD}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Average Cost:</label>
                                    <label className="item-details-value mb-2">{childItem.ITEM_COST}</label>
                                </div>
                                {/*<div className="col-md-4 pr-0 mb-2">
                            <label className="catalog-label mr-2">StoreRoom Type:</label>
                            <label className="item-details-value mb-2">{childItem.STOREROOMTYPE}</label>
                        </div>*/}
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">StoreRoom Description:</label>
                                    <label className="item-details-value mb-2">{childItem.STOREDESCR}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">UOM:</label>
                                    <label className="item-details-value mb-2">{childItem.UNIT_OF_MEASURE}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Item Master Charge Code:</label>
                                    <label className="item-details-value mb-2">{childItem.MASTER_CHARGE_CD}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Bin Location:</label>
                                    <label className="item-details-value mb-2">{childItem.STORLOC}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Exceeded Budget:</label>
                                    <label className="item-details-value mb-2">{childItem.ISA_BUDGET_EX_FLAG}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Signature:</label>
                                    <label className="item-details-value mb-2">{childItem.SIG_FULLNAME}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">MFG:</label>
                                    <label className="item-details-value mb-2">{childItem.MFGNAME}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Tracking Number:</label>
                                    <a href={"http://wwwapps.ups.com/WebTracking/processInputRequest?HTMLVersion=5.0&sort_by=status&term_warn=yes&tracknums_displayed=5&TypeOfInquiryNumber=T&loc=en_US&InquiryNumber1= " + childItem.TRACK_NO + "&InquiryNumber2=&InquiryNumber3=&InquiryNumber4=&InquiryNumber5=&AgreeToTermsAndConditions=yes&track.x=25&track.y=9"} target="_blank" >{childItem.TRACK_NO} </a>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Date Picked:</label>
                                    <label className="item-details-value mb-2">{childItem.DATEPICKED}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Date Shipped:</label>
                                    <label className="item-details-value mb-2">{childItem.DATESHIPPED}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Order Status:</label>
                                    <label className="item-details-value mb-2">{childItem.ORDERSTATUS}</label>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>)

        })
    };
    render() {
        return (
            <div className="container-fluid content-margin content-section">
                <div className="row">
                    <div className="col-md-12 page-heading mb-3">
                        <h5 className="page-title"><span>SDI</span> <Trans>Stock Issues Report</Trans></h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-Fav" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-Fav">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 col-lg-2 mb-3">
                                        <label className="catalog-label w-100 mandatory-after"><Trans>Select ReportKey</Trans></label>
                                        <span style={{ "fontSize": "12px" }}><Select
                                            id="buddid"
                                            name="BuDD"
                                            onChange={(e) => this.handleDDChange(e)}
                                            value={{ label: this.state.DropDownText }}
                                            options={Options}
                                            defaultValue="Select"
                                            placeholder="Select"
                                        /></span>
                                    </div>
                                    <div className="col-md-4 col-lg-2 mb-3">
                                        <label className="catalog-label w-100"><Trans>Employee Name</Trans></label>
                                        <span style={{ "fontSize": "12px" }}><Select
                                            id="buddid"
                                            name="BuDD"
                                            onChange={(e) => this.handleEmpChange(e)}
                                            defaultValue="Select"
                                            value={{ label: this.state.EmpName }}
                                            options={this.state.EmpOptions}
                                            placeholder="Select"
                                        /></span>
                                    </div>
                                    <div className="col-md-4 col-lg-2 mb-3" >{/*col-lg-6 col-md-12 float-left p-0 col-12**/}
                                        <label className="catalog-label w-100"><Trans>workorder_key</Trans> <span> #</span></label>
                                        <input onChange={this.handleWOInput} className="form-control charge-code-control" placeholder="Enter value" id="OLWorkOrderTB" value={this.state.WOrkorder} type="text" maxlength="9" />

                                        {/*//<input type="number" style={{ width: "246px" }} min="0" oninput="validity.valid||(value='');" className="form-control charge-code-control" placeholder="Enter value" id="OLWorkOrderTB" max="10" defaultValue={''} />
                                    //    {/*04/22/22,PC_WW-365_03], Priyanka D */}
                                    </div>
                                    <div className="col-md-4 col-lg-2 mb-3">
                                        <label className="catalog-label w-100"><Trans>Select</Trans><span> BU</span></label>
                                        <span style={{ "fontSize": "12px" }}>
                                            <Select
                                                id="buddid"
                                                name="BuDD"
                                                onChange={(e) => this.handleBUDDChange(e)}
                                                value={{ label: this.state.BUDDDisplayName }}
                                                defaultValue="Select"
                                                options={this.state.BUOptions}
                                                style={{ "width": "80px" }}
                                            /></span>
                                    </div>
                                    <div className="col-md-4 col-lg-2 mb-3" id="PrivTypeDIv">
                                        <label className="catalog-label w-100">Pick-up</label>
                                        <div className="w-100">
                                            <label className="custom-radiobtn mr-2 my-2"><Trans>Yes</Trans>
                                                <input type="radio" id="Pickup" name="radio2" onClick={() => this.OnchangePick("0")} />
                                                <span className="checkmark" />
                                            </label>
                                            <label className="custom-radiobtn mr-2 my-2"><Trans>No</Trans>
                                                <input type="radio" id="NotPickup" name="radio2" onClick={() => this.OnchangePick("1")} />
                                                <span className="checkmark" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`col-md-12 ${this.state.isSearchByDate ? 'd-block' : 'd-none'}`} id="searchbydateid" >
                                <div className="row">
                                    <div className="col-md-2 mb-4">
                                        <label className="catalog-label"><Trans>From</Trans></label>
                                        {/*<DatePicker className="form-control "
                                                        id="OrderByFromDate"
                                                        fixedHeight
                                                      
                                                        placeholderText="MM/DD/YYYY"
                                                        dateFormat="MM/dd/yyyy"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        //dropdownMode="select"
                                                        //minDate={new Date()}
                                                        value={this.state.SearchTrFromDate}
                                                        onChange={this.SearchTrFromDatebind}

                                                    />*/}
                                        <DatePicker className="form-control" style={{ "fontSize": "12px" }}
                                            id="OF"
                                            fixedHeight
                                            placeholderText="MM/DD/YYYY"
                                            dateFormat="MM/dd/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            selected={this.state.OFromDate}
                                            maxDate={this.state.OToDate}
                                            onChange={(e) => this.handleDatePicker(e, "OFromDate")}
                                        />
                                        <span className="calendar-icon filter-calendar-icon stock-issue-calendar float-left" onClick={() => $(`#OF`).focus()} />

                                    </div>
                                    <div className="col-md-2 mb-4">
                                        <label className="catalog-label">To <span className="info-container"><img className="info-searchpage" src="Images/info-icon.png" /><span className="info-content info-position"><Trans>date range is limited to 3 months</Trans></span></span></label>
                                        {/*<DatePicker className="form-control "
                                                        id="OrderByToDate"
                                                        fixedHeight
                                                        
                                                        placeholderText="MM/DD/YYYY"
                                                        dateFormat="MM/dd/yyyy"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        //dropdownMode="select"
                                                        //minDate={new Date()}
                                                        value={this.state.SearchTrToDate}
                                                        onChange={this.SearchTrToDatebind}

                                                    />*/}
                                        <DatePicker className="form-control" style={{ "fontSize": "12px" }}
                                            id="OT"
                                            fixedHeight
                                            placeholderText="MM/DD/YYYY"
                                            dateFormat="MM/dd/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            selected={this.state.OToDate}
                                            minDate={this.state.OFromDate}
                                            onChange={(e) => this.handleDatePicker(e, "OToDate")}
                                        />
                                        <span className="calendar-icon filter-calendar-icon stock-issue-calendar float-left" onClick={() => $(`#OT`).focus()} />

                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 col-sm-auto col-auto col-lg-12 text-right my-3">
                                <button className="btn btn-primary custom-btn-primary primary-btn px-3" onClick={this.GoClick}><Trans>GO</Trans></button>
                                <button className="btn btn-secondary custom-btn-secondary secondary-btn px-3 ml-2" onClick={this.ClearClick}><Trans>Clear</Trans></button>
                            </div>

                            {this.state.GridArray.length > 0 ?

                                <div className="col-md-12 col-sm-auto col-auto text-right my-3">

                                    <label className="catalog-label w-100">Total:&nbsp; $&nbsp;{this.state.total} </label>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-3 mr-2 mb-2" onClick={() => this.expandAll()}><Trans>Expand</Trans><span> </span><Trans>All</Trans></button>
                                    <span> </span><button className="btn btn-primary custom-btn-primary primary-btn px-3 mb-2 mr-2" onClick={() => this.collapseAll()}><Trans>Collapse</Trans><span> </span><Trans>All</Trans></button>
                                    <span> </span><button className="btn btn-primary custom-btn-primary d-inline primary-btn px-3 mb-2 mr-2" onClick={() => this.ExportToExcelClick()}><Trans>Export To Excel</Trans></button>
                                </div> : null}
                        </div>

                        {this.state.GridArray.length > 0 ?
                            <div>
                                <div className="table-responsive">
                                    <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                        <thead>
                                            <tr>
                                                <th className="position-sort-icon" />
                                                <th className="position-sort-icon"><Trans>ItemKey</Trans><span> </span><Trans>ID</Trans><span className="sort-up ml-1 mb-1"><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "PRODUCT_ID")} /></span><span className="sort-downi ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "PRODUCT_ID")} /></span></th>
                                                <th className="d-md-table-cell position-sort-icon" ><Trans>order_key</Trans><span> #</span><span className="sort-up ml-1 mb-1"><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "ORDER_NO")} /></span><span className="sort-downi ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "ORDER_NO")} /></span></th>
                                                <th className="d-md-table-cell " ><Trans>Short</Trans><span> </span><Trans>Description</Trans></th>
                                                <th className="d-md-table-cell position-sort-icon"><Trans>Ship From</Trans> BU</th>
                                                <th className="d-md-table-cell position-sort-icon" >Ln Nbr</th>
                                                <th className="d-md-table-cell position-sort-icon" >QTY</th>
                                                <th className="d-md-table-cell position-sort-icon" ><Trans>Serial</Trans><span> </span><Trans>Id</Trans></th>
                                                <th className="d-md-table-cell position-sort-icon" ><Trans>Total Dollars</Trans></th>
                                                <th className="d-md-table-cell position-sort-icon"><Trans>Employee</Trans><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "ISA_EMPLOYEE_NAME")} /></span><span className="sort-downi ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "ISA_EMPLOYEE_NAME")} /></span></th>
                                                {/* <th className="d-none d-sm-none d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Employee</Trans><span> </span><Trans>Id</Trans><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "ISA_EMPLOYEE_ID")} /></span><span className="sort-downi ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "ISA_EMPLOYEE_ID")} /></span></th>*/}
                                                <th className="d-md-table-cell "><Trans>workorder_key</Trans> #</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.BindGridData()}
                                        </tbody>
                                    </table>
                                </div>

                                {this.state.totalCount > 0 ?
                                    <div className="col-md-12 my-3 ">
                                        <span className="total-records mb-2">
                                            <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                        </span>
                                        {this.state.totalCount > this.state.itemCount ? <ReactPaginate
                                            previousLabel={<span className="right-pagination-arrow" />}
                                            nextLabel={<span className="left-pagination-arrow" />}
                                            previousClassName={'page-item'}
                                            nextClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextLinkClassName={'page-link'}
                                            disabledClassName={'disabled'}
                                            breakLabel={'...'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'custom-pagination pagination float-right'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                            hrefBuilder={() => '#'}
                                            forcePage={this.state.pageNo - 1}
                                        /> : null}

                                    </div> : null}

                            </div> : this.state.IsPageLoad == false ? (<section className="site-undercontruction container text-center center-panel pt-4">
                                <div className="img-section">
                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                </div>
                                <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                </p>
                            </section>) : null}
                    </div>
                </div>
                {/* <div className={`dropdown-menu SearchByDate-filter-added m-0 mobile-filter-ch-new advancealign ${this.state.isSearchByDate ? 'd-block' : ''}`} id="searchbydateid" >
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                            <div className="col-md-12 p-0 pb-2 border-bottom  mb-3">
                                    <span className="filter-title pl-3"><Trans>Search by</Trans><span> </span><Trans>Date</Trans></span>
                                    <button type="button" className="filter-close close pr-2 filter-btn" onClick={this.closeButtonClick}><span className="filter-close-icon" /></button>
                            </div>

                            <div className="col-md-12">
                                    <label className="catalog-label col-md-12 float-left mb-0"> <span>(</span><Trans>date range is limited to 3 months</Trans><span>)</span></label>
                                <div className="col-md-6 float-left mb-4">
                                    <label className="catalog-label mb-0"><Trans>From</Trans></label>
                                    <DatePicker className="form-control"
                                        id="OF"
                                        fixedHeight
                                        placeholderText="MM/DD/YYYY"
                                        dateFormat="MM/dd/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        selected={this.state.OFromDate}
                                        maxDate={this.state.OToDate}
                                        onChange={(e) => this.handleDatePicker(e, "OFromDate")}
                                    />
                                    <span className="calendar-icon filter-calendar-icon" onClick={() => $(`#OF`).focus()} />

                                </div>
                                <div className="col-md-6 float-left mb-4">
                                    <label className="catalog-label mb-0 w-100"><Trans>To</Trans></label>
                                    <DatePicker className="form-control"
                                        id="OT"
                                        fixedHeight
                                        placeholderText="MM/DD/YYYY"
                                        dateFormat="MM/dd/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        selected={this.state.OToDate}
                                        minDate={this.state.OFromDate}
                                        onChange={(e) => this.handleDatePicker(e, "OToDate")}
                                    />
                                    <span className="calendar-icon filter-calendar-icon" onClick={() => $(`#OT`).focus()} />

                                </div>
                            </div>
                            <div className="col-md-12 mb-2">
                                <div className="float-right">
                                    <button className="btn btn-primary filter-clear-btn px-4 mr-2 filter-btn" onClick={this.clearButtonClick}><Trans>Clear</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary filter-btn primary-btn wallet-btn px-4" onClick={this.SubmitClick}><Trans>Submit</Trans></button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>*/}
            </div>
        );
    };
}
export default withTranslation()(StockIssueComponent);